import { i18n } from '@/locales/setupI18n'
import { useI18n } from 'vue-i18n'

export function useGlobalI18n() {
  const { t, ...methods } = i18n.global
  const tProxy = (key: string, ...args: any[]) => {
    return (t as CallableFunction)(key, ...args)
  }
  return {
    t: tProxy,
    ...methods,
  }
}

export function useTranslatePlaceholder(t: ReturnType<typeof useI18n>['t']) {
  function tInputPlaceholder(placeholder: string) {
    return t('请输入{placeholder}', { placeholder: t(placeholder) })
  }

  function tSelectPlaceholder(placeholder: string) {
    return t('请选择{placeholder}', { placeholder: t(placeholder) })
  }

  return {
    tInputPlaceholder,
    tSelectPlaceholder,
  }
}
